import type { App } from 'vue'
import {
  BarChart,
  LineChart,
  PieChart,
} from 'echarts/charts'
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
} from 'echarts/components'
import { use } from 'echarts/core'
import {
  CanvasRenderer,
  SVGRenderer,
} from 'echarts/renderers'
import ECharts, { THEME_KEY } from 'vue-echarts'

export function installCharts(app: App<Element>) {
  use([
    SVGRenderer,
    LineChart,
    BarChart,
    GridComponent,
    ToolboxComponent,
    CanvasRenderer,
    PieChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
  ])

  app.provide(THEME_KEY, 'light')
  app.component('VChart', ECharts)
}
